// src/components/FeaturesSection.jsx
import React from "react";
import "../assets/css/Features.css";
import studentIcon from "../assets/imgs/student-icon.avif";
import ecIcon from "../assets/imgs/ec-icon.avif";
import franchiseIcon from "../assets/imgs/f-icon.jpg";

const Features = () => {
  const features = [
    {
      img: studentIcon,
      title: "For Students",
      desc: "Learn, grow, and get guided by certified educational counsellors. Easy enrollment and subject-wise learning.",
      link: "#student",
    },
    {
      img: ecIcon,
      title: "For Educational Counsellors",
      desc: "Become an Abhyas Mitra, manage student enrollments, and grow your network with performance-based rewards.",
      link: "#counsellor",
    },
    {
      img: franchiseIcon,
      title: "For Franchises",
      desc: "Build your educational franchise at district or taluka level. Manage ECs, admissions, and revenue seamlessly.",
      link: "#franchise",
    },
  ];

  return (
    <section className="features-section" id="about">
      <h2 className="section-title">Why Choose <span>Aabhyas Mitra</span>?</h2>
      <div className="feature-grid">
        {features.map((item, index) => (
          <div key={index} className="feature-card">
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <a href={item.link} className="learn-more">Learn More →</a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
